var ua = navigator.userAgent.toLocaleLowerCase();

const publicVar = {

    // 平板（包括 ipad 和 apad）
    isPad: ua.indexOf("apad") > -1 || ua.indexOf("ipad") > -1 ? true : false,
    isIpad: ua.indexOf("ipad") > -1 ? true : false,
    isApad: ua.indexOf("apad") > -1 ? true : false,

    isMobile: ua.indexOf("mobile") > -1 ? true : false,
    // ios 设备（由于目前有的机型，存在 UA 会被截断的问题，所以需要加上 iphone。后面 ios 会在头部添加 app 的唯一标识）
    isIos: ua.indexOf("kidlearning_inapp_ios") > -1 || ua.indexOf("iphone") > -1 ? true : false,
    // android 设备
    isAndroid: ua.indexOf("androidbrowser") > -1 || ua.indexOf("kidlearning_inapp_android") > -1 ? true : false,

    // app（由于目前有的机型，存在 UA 会被截断的问题，所以需要加上 iphone。后面 ios 会在头部添加 app 的唯一标识。在微信中使用是要特殊注意，因为后面添加了 iphone。微信中也会被认为是 ios app）
    isApp: ua.indexOf("androidbrowser") > -1 || ua.indexOf("kidlearning_inapp_android") > -1 || ua.indexOf("kidlearning_inapp_ios") > -1 || ua.indexOf("iphone") > -1 || window.sendGrapes ? true : false,

    // 这个能正确判断出来 APP，不会包含微信
    isRealApp: ua.indexOf("androidbrowser") > -1 || ua.indexOf("kidlearning_inapp_android") > -1 || ua.indexOf("kidlearning_inapp_ios") > -1 || window.sendGrapes ? true : false,

    isWx: ua.indexOf("micromessenger") > -1 ? true : false,

    isPC: function () {
        let Agents = ['android', 'iphone', 'symbianos', 'windows phone', 'ipad', 'ipod'];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
            if (ua.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    },
    isWxPc: ua.indexOf("android") === -1 && ua.indexOf("iphone") === -1 && ua.indexOf("micromessenger") > -1 ? true : false,
    isMac: ua.indexOf("Mac") > -1 ? true : false,

    isPhone: (ua.indexOf("android") > -1 || ua.indexOf("iphone") > -1) && (window.innerWidth < window.innerHeight) ? true : false
}

window.vertical = publicVar.isPhone || publicVar.isWx || (window.innerWidth < window.innerHeight); //竖屏

export default publicVar;


// WEBPACK FOOTER //
// ./src/lib/publicData/global_variable.js